<template>
  <div :class="_fs_class">
    <inline-menu
      :label="filterLength > 0 ? filterLength + ' ' + appendText : noFilterText"
      :labelMenu="label"
      html
      :menuButtonId="id ? id : null"
      button
      :link="filterLength < 1"
      :secondary="filterLength > 0"
      :trigger-class="filterLength > 0 ? 'mln small' : 'mln small simple'"
      class="pbn mln"
      :allow-clear="filterLength > 0"
      :clear-text="clearText"
      triggerAriaLive="polite"
      @ui-key-down="onKeyDown"
      @ui-close="_onClose"
      @ui-clear="_resetFilters"
      @ui-open="_onOpen"
    >
      <div ref="theMenu" class="" @keydown="onKeyDown">
        <div v-if="enableSearch" class="cat-menu-dropdown-header ps border-b">
          <div class="fieldset cat-search-field dense pbn">
            <label
              v-if="searchLabel"
              :for="id + '_search'"
              :aria-labelledby="id + '_text'"
              class="cat-label"
              ><span :id="id + '_text'" class="label-text">{{
                searchLabel
              }}</span></label
            >
            <div class="input-holder">
              <div class="cat-input">
                <input
                  :id="id + '_search'"
                  ref="searchField"
                  v-model="searchTerm"
                  :aria-label="
                    searchOffscreenLabel ? searchOffscreenLabel : null
                  "
                  :placeholder="placeholder"
                  type="text"
                  @change="_onSearch"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="cat-menu-dropdown-body pt">
          <ul>
            <li v-for="(fltr, idx) in filteredList" :key="idx">
              <cat-check-box
                :id="id + '_' + fltr.id"
                dense
                :selected="fltr.selected"
                :value="fltr.id"
                :label="fltr.label"
                class="mtx pbx"
                @ui-focus="filterCursor = idx"
                @ui-change="_onFilterChange($event, idx, filtersModel, fltr.id)"
                @ui-key-down="onKeyDown(e, idx)"
              ></cat-check-box>
            </li>
          </ul>
        </div>
        <div class="cat-menu-dropdown-footer plt prt border-t"></div>
      </div>
    </inline-menu>
    <!--<cat-btn v-if="filterLength > 0" small simple link @ui-click="_resetFilters">Clear Filters</cat-btn>-->
  </div>
</template>
<script lang="ts">
import jQuery from "jquery";
import { defineComponent } from "vue";
import InlineMenu from "@/components/catMenu/catMenu";
// import CatAttributeText from "@/components/catAttributeText/catAttributeText";
import CatCheckBox from "@/components/catCheckBox/catCheckBox";
import { defaultStopProcessUpdate } from "@/components/utilities/processUpdateMixin";

export default defineComponent({
  name: "CatFilterSelect",
  components: {
    CatCheckBox,
    // CatAttributeText,
    InlineMenu
  },
  inject: {
    stopProcessUpdate: {
      from: "stopProcessUpdate",
      default: () => defaultStopProcessUpdate
    }
  },
  provide: function () {
    return {
      displayParams: {
        showLabelOptional: false,
        showLabelRequired: false,
        suppressOffscreenOptional: true,
        suppressOffscreenRequired: true
      }
    };
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
      description: "Filter select ID."
    },
    placeholder: {
      type: String,
      description: "Placeholder text for the search field."
    },
    filters: {
      type: [Array],
      description: "List of filter items.",
      required: true
    },
    clearText: {
      type: String,
      description: "Text for 'clear filter' tooltip."
    },
    appendText: {
      type: String,
      description:
        "Text that will be added after the number of selected filters. For example 'x filters selected'."
    },
    noFilterText: {
      type: String,
      description: "Text when no filter selected."
    },
    searchLabel: {
      type: String,
      description: "Label for the search field."
    },
    searchOffscreenLabel: {
      type: String,
      description: "Text for 'aria-label' of the search field.'"
    },
    label: {
      type: String,
      description: "Label for filter select link."
    },
    enableSearch: {
      type: Boolean,
      description: "Trigger to enable or disable search."
    },
    searchColumn: {
      type: String,
      default: "label",
      description:
        "The key that identifies the items to search within. Default value 'label'."
    },
    searchValue: {
      type: String,
      description: "Search term value."
    },
    inlinefields: {
      type: Boolean,
      default: false,
      description:
        "Sets the element to display as inline. Default value 'false'."
    }
  },
  data: function () {
    return {
      filterCursor: 0,
      filtersModel: {},
      searchTerm: this.searchValue
    };
  },
  computed: {
    _fs_class: function () {
      return {
        "cat-filter-select": true,
        "inline-fields": this.inlinefields
      };
    },
    filterLength: function () {
      return this.filtersModel.filter(function (x) {
        return x.selected;
      }).length;
    },
    filteredList: function () {
      var self = this;
      return self.enableSearch
        ? self.filtersModel.filter(function (item) {
            return item[self.searchColumn]
              .toLowerCase()
              .includes(self.searchTerm.toLowerCase());
          })
        : self.filtersModel;
    }
  },
  methods: {
    _onSearch: function (e) {
      // console.log("SEARCHed", e);
      if (e.event && e.event.target && e.event.target.value) {
        this.searchTerm = e.event.target.value;
      }
    },
    _onOpen: function (e) {
      var _this = this;
      _this.$emit("ui-open", e);
      jQuery(_this.$refs.searchField).focus();
    },
    onKeyDown: function (e, idx) {
      this.$emit("ui-key-down");
      if (e.keyCode === 40) {
        // console.log("ARROW DOWN", [e, idx]);
      }

      if (e.keyCode === 38) {
        // console.log("ARROW UP", [e, idx]);
      }
    },
    _onFilterChange(e, idx, model, id) {
      // console.log("HEY", [e,idx]);
      this.filtersModel[idx].selected = e.value;
      this.$emit("ui-change", { event: e, idx: idx, filters: model, id: id });
      this.stopProcessUpdate(
        "catFilterSelect.vue name: cat-filter-select method: _onFilterChange"
      );
    },
    _onClose: function (e) {
      this.filterCursor = 0;
      this.$emit("ui-close", e);
    },
    _resetFilters() {
      var _this = this;
      _this.filtersModel.forEach(function (filter, idx) {
        _this.filtersModel[idx].selected = false;
      });
      this.$emit("ui-reset");
    }
  },
  created() {
    this.filtersModel = this.filters;
  },
  beforeUnmount() {
    this.filtersModel = {};
  }
});
</script>
